import { createFileRoute, redirect } from "@tanstack/react-router";

// Contact merged into About; keep old /contact links working.
export const Route = createFileRoute("/contact")({
  beforeLoad: () => {
    throw redirect({ to: "/about", hash: "contact" });
  },
});
